import React from "react";
import "./maxWidthWrapper.scss";

export const MaxWidthWrapper = ({ children }) => {
  return <div className="bwl-max-width-wrapper">{children}</div>;
};
